import { IShellEvent } from './IShellEvent';
import { ShellCommunicationEvents } from '@shared/generalInterfaces';
import { Injectable } from '@angular/core';
import { ApplicationNavigationService } from 'app/services/shell/application-navigation/application-navigation.service';
import { allowedApps } from '../data/allowedApps';
import { CloseMe } from '@nodeModules/@itero/itero-client-communication';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class CloseMeEvent implements IShellEvent {
	private readonly unhandeledCloseMeSubject = new BehaviorSubject<CloseMe>(null);
	public unhandeledCloseMe$: Observable<CloseMe> = this.unhandeledCloseMeSubject.asObservable();

	constructor(private applicationNavigationService: ApplicationNavigationService) { }

	get eventName(): string {
		return ShellCommunicationEvents.CloseMe;
	}

	handleCustomEvent(event: any) {
		if (allowedApps.includes(event.eventHeader.publisher)) {
			this.applicationNavigationService.navigateBack(event.eventHeader.publisher);
		}
		this.unhandeledCloseMeSubject.next(event);
	}

	handlePostMessage(event): void {}
}